const STORAGE_KEY = 'promotionReports_searchHistory'
const MAX_HISTORY_ITEMS = 5

export interface SearchHistory {
  phone: string
  timestamp: number
}

export const saveSearchHistory = (phone: string): void => {
  const history = getSearchHistory()
  const newHistory: SearchHistory[] = [
    { phone, timestamp: Date.now() },
    ...history.filter((h) => h.phone !== phone),
  ].slice(0, MAX_HISTORY_ITEMS)

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory))
  } catch (error) {
    console.error('Failed to save search history:', error)
  }
}

export const getSearchHistory = (): SearchHistory[] => {
  try {
    const data = localStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : []
  } catch (error) {
    console.error('Failed to get search history:', error)
    return []
  }
}

export const clearSearchHistory = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error('Failed to clear search history:', error)
  }
}

export const removeSearchHistoryItem = (phone: string): void => {
  const history = getSearchHistory()
  const newHistory = history.filter((h) => h.phone !== phone)

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory))
  } catch (error) {
    console.error('Failed to remove search history item:', error)
  }
}
